import { render, staticRenderFns } from "./dailyCuringCost.vue?vue&type=template&id=523aa09a&scoped=true&"
import script from "./dailyCuringCost.vue?vue&type=script&lang=js&"
export * from "./dailyCuringCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523aa09a",
  null
  
)

export default component.exports